// Action Types
export const TEMPLATES_FETCH_REQUEST = "TEMPLATES_FETCH_REQUEST";
export const TEMPLATES_FETCH_SUCCESS = "TEMPLATES_FETCH_SUCCESS";
export const TEMPLATES_FETCH_FAILURE = "TEMPLATES_FETCH_FAILURE";
export const TEMPLATES_CREATE_REQUEST = "TEMPLATES_CREATE_REQUEST";
export const TEMPLATES_CREATE_SUCCESS = "TEMPLATES_CREATE_SUCCESS";
export const TEMPLATES_CREATE_FAILURE = "TEMPLATES_CREATE_FAILURE";
export const TEMPLATES_UPDATE_REQUEST = "TEMPLATES_UPDATE_REQUEST";
export const TEMPLATES_UPDATE_SUCCESS = "TEMPLATES_UPDATE_SUCCESS";
export const TEMPLATES_UPDATE_FAILURE = "TEMPLATES_UPDATE_FAILURE";
export const TEMPLATES_DELETE_REQUEST = "TEMPLATES_DELETE_REQUEST";
export const TEMPLATES_DELETE_SUCCESS = "TEMPLATES_DELETE_SUCCESS";
export const TEMPLATES_DELETE_FAILURE = "TEMPLATES_DELETE_FAILURE";
export const TEMPLATES_SET_FILTERS = "TEMPLATES_SET_FILTERS";
export const TEMPLATES_CLEAR_ERROR = "TEMPLATES_CLEAR_ERROR";
